import React from 'react';

const Header = () => {
  return null; // Return null to remove the header
};

export default Header;
